import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import ContentDialog from '@/Pages/Sessions/uiComponents/ContentDialog/ContentDialog';
import RenameTitleModal from '@/Pages/Sessions/AssetsTable/RenameTitleModal';
import { useClipTitleRename } from '@/hooks/useClipTitleRename';

const ClipTitlePopup = () => {
  const { clipData } = useClipsContext();
  const { renamingClip, onSaveNewTitle, closeRenamingClipDialog, setRenamingClip } = useClipTitleRename();
  return (
    <>
      <div
        className="min-w-0 max-w-[294px] cursor-pointer truncate rounded-lg px-2 py-0.5 text-base font-medium leading-tight text-slate-900 hover:bg-slate-200"
        title={clipData.title}
        onClick={() => setRenamingClip(clipData)}
      >
        {clipData.title}
      </div>
      {renamingClip ? (
        <ContentDialog isOpen={!!renamingClip} setIsOpen={closeRenamingClipDialog} title="Rename" size="xsmall">
          <RenameTitleModal
            existingTitle={renamingClip.title}
            onSubmit={onSaveNewTitle}
            onClose={closeRenamingClipDialog}
          />
        </ContentDialog>
      ) : null}
    </>
  );
};

export default ClipTitlePopup;
